import { atom } from 'recoil'
import { getDefaultRSObject } from '../apiClient'
import { RequestState } from '../dataDefinitions/request'
import { SigningRequestCountSummaryPerOwner } from '../dataDefinitions/signingRequest'

export const pendingCountSummaryPerOwnerRSatom = atom<RequestState<SigningRequestCountSummaryPerOwner>>({
    key: 'pendingCountSummaryPerOwner',
    default: getDefaultRSObject()
})